export default "__VITE_ASSET__BBuJTrg5__"